{
  "nl": {
    "datatable": {
      "actions": {
        "add_filter": "Filter toevoegen",
        "bulk_action": "Actie in bulk",
        "bulk_edit": "Bewerk in bulk",
        "clear": "Wissen",
        "clear_filters": "Filters wissen",
        "collapse_all": "Alles dichtklappen",
        "collapse_row": "Rij dichtklappen",
        "deselect_all": "Alles deselecteren",
        "expand_all": "Alles openklappen",
        "expand_row": "Rij openklappen",
        "filters": "Filters",
        "remove_filter": "Filter {label}: {value} verwijderen",
        "select_all": "Alles selecteren",
        "select_row": "Rij selecteren"
      },
      "import": {
        "error_row": "Rij {row}",
        "errors_description": "De import is geannuleerd omdat {count} rij(en) fouten bevatten. Er zijn geen records geïmporteerd.",
        "errors_title": "Import mislukt",
        "success": "Bestand succesvol geïmporteerd",
        "title": "Importeren"
      },
      "labels": {
        "active_filters": "Actieve filters",
        "columns_selected": "{count} kolommen geselecteerd",
        "freeze_columns": "Kolommen vastzetten",
        "freeze_rows": "Rijen vastzetten",
        "gridlines": "Rasterlijnen",
        "group_by": "Groeperen op",
        "size": "Grootte",
        "sticky_headers": "Vaste kopteksten",
        "striped_rows": "Gestreepte rijen",
        "toggle_columns": "Kolommen tonen/verbergen",
        "translation_mode_header": "Kolomkop",
        "translation_mode_stacked": "Gestapeld",
        "translation_mode_toolbar": "Globaal",
        "translation_style": "Vertaalstijl"
      }
    }
  }
}
